import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t bg-background mt-auto">
      <div className="container py-8 md:py-12 px-4 sm:px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <h3 className="font-bold text-lg mb-2">Let's Be Real</h3>
            <p className="text-sm text-muted-foreground mb-4 max-w-md">
              Brutally honest, data-driven property insights for Australian addresses. 
              No fluff, no sugar-coating, just the truth.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-3 text-sm">Explore</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <button
                  onClick={() => navigate("/")}
                  className="text-muted-foreground hover:text-foreground transition-colors"
                >
                  Search Properties
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate("/sample-reports")}
                  className="text-muted-foreground hover:text-foreground transition-colors"
                >
                  Sample Reports
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate("/blog")}
                  className="text-muted-foreground hover:text-foreground transition-colors"
                >
                  Blogs
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate("/faq")}
                  className="text-muted-foreground hover:text-foreground transition-colors"
                >
                  FAQ
                </button>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold mb-3 text-sm">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <button
                  onClick={() => navigate("/about")}
                  className="text-muted-foreground hover:text-foreground transition-colors"
                >
                  About & Contact
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate("/privacy")}
                  className="text-muted-foreground hover:text-foreground transition-colors"
                >
                  Privacy Policy
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t mt-8 pt-8 text-center text-sm text-muted-foreground">
          <p>© {currentYear} Let's Be Real. Made with data, humor, and honesty.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

